<template>
	<div class="d-flex flex-column min-vh-100">
		<nav class="py-2 px-md-2 border-bottom border-4 border-danger navbar navbar-expand-md navbar-dark text-bg-dark bg-dark">
			<div class="container-fluid">
				<router-link :to="{ path: '/' }" class="navbar-brand">
					<h1 class="d-flex align-items-center fs-4 mb-0">
						<img
							src="/assets/images/logo-full.png"
							class="me-3"
							alt="SKV: СИСТЕМА КОНТРОЛЯ ВЕРСИЙ"
						/>
					</h1>
				</router-link>
				<!--
				<ul class="nav justify-content-center d-none d-sm-flex">
					<li v-for="item in sidebar" :key="item.name">
						<router-link custom :to="item.link"
							v-slot="{href, navigate, isActive, isExactActive}">
							<a
								:href="href"
								@click="navigate"
								class="nav-link px-2"
								:class="{
									'text-white': !isActive,
									'text-secondary': isActive
								}"
							>
								<svg
									v-if="item.svg"
									xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 24 24"
									:fill="currentColor"
									width="20"
									height="20"
									class="me-2"
									v-html="item.svg"
								></svg>
								<span>{{item.name}}</span>
							</a>
						</router-link>
					</li>
				</ul>
				-->
				<div class="d-flex align-items-center justify-content-between">
					<div class="dropdown" v-if="authModel.isAuth()">
						<a
							href="javascript://"
							class="d-flex align-items-center link-body-emphasis text-decoration-none"
							data-bs-toggle="dropdown"
							aria-expanded="false"
						>
							<div class="me-2 text-white d-none d-md-inline-block">{{ authModel.getLogin() }}</div>
							<image-with-placeholder
								:src="authModel.getAvatar()"
								class="ratio ratio-1x1 rounded"
								width="32px"
								height="100%"
								skeleton="shimmer"
								alt="ava"
							/>
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#fff" width="20" height="20">
								<path d="M7,10L12,15L17,10H7Z" />
							</svg>
						</a>
						<ul class="dropdown-menu dropdown-menu-end">
							<li class="d-inline-block d-md-none">
								<h6 class="dropdown-header">
									{{ authModel.getLogin() }}
								</h6>
							</li>
							<li v-if="authModel.isAdmin()">
								<router-link custom :to="{ path: '/settings' }" v-slot="{ href, navigate, isActive, isExactActive }">
									<a
										:href="href"
										@click="navigate"
										class="dropdown-item"
										:class="{ active: isActive }"
									>Настройки</a>
								</router-link>
							</li>
							<li>
								<router-link custom :to="{ path: '/profile-settings' }" v-slot="{ href, navigate, isActive, isExactActive }">
									<a
										:href="href"
										@click="navigate"
										class="dropdown-item"
										:class="{ active: isActive }"
									>Аккаунт</a>
								</router-link>
							</li>
							<li>
								<router-link :to="{ path: '/logout' }" class="dropdown-item">Выйти</router-link>
							</li>
						</ul>
					</div>
					<div class="d-none d-md-block" v-else>
						<ul class="navbar-nav">
							<li class="nav-item">
								<router-link custom :to="{ path: '/login' }" v-slot="{ href, navigate, isActive, isExactActive }">
									<a
										:href="href"
										@click="navigate"
										class="nav-link d-flex align-items-center py-0"
										:class="{ active: isActive }"
									>
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20" height="20" class="me-2">
											<path d="M11 7L9.6 8.4L12.2 11H2V13H12.2L9.6 15.6L11 17L16 12L11 7M20 19H12V21H20C21.1 21 22 20.1 22 19V5C22 3.9 21.1 3 20 3H12V5H20V19Z" />
										</svg>
										<span>Войти</span>
									</a>
								</router-link>
							</li>
						</ul>
					</div>
					<button class="navbar-toggler ms-2" type="button" data-bs-toggle="collapse" data-bs-target="#navbarHeader">
						<span class="navbar-toggler-icon"></span>
					</button>
				</div>
			</div>
			<div class="container-fluid d-block d-md-none">
				<div class="collapse navbar-collapse" id="navbarHeader">
					<ul class="navbar-nav me-auto mb-0">
						<template v-if="authModel.isAuth()">
							<li
								class="nav-item"
								v-for="item in filteredSidebar" :key="item.name"
							>
								<router-link custom :to="item.link" v-slot="{ href, navigate, isActive, isExactActive}">
									<a
										:href="href"
										@click="navigate"
										class="nav-link d-flex align-items-center"
										:class="{ active: item.link == '/' ? isExactActive : isActive }"
									>
										<svg v-if="item.svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20" height="20" class="me-2" v-html="item.svg"></svg>
										<span>{{ item.name }}</span>
										<div class="badge bg-secondary flex-shrink-0 ms-auto" v-if="item.count">{{ item.count }}</div>
									</a>
								</router-link>
							</li>
						</template>
						<li class="nav-item" v-else>
							<router-link custom :to="{ path: '/login' }" v-slot="{ href, navigate, isActive, isExactActive }">
								<a
									:href="href"
									@click="navigate"
									class="nav-link d-flex align-items-center"
									:class="{ active: isActive }"
								>
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20" height="20" class="me-2">
										<path d="M11 7L9.6 8.4L12.2 11H2V13H12.2L9.6 15.6L11 17L16 12L11 7M20 19H12V21H20C21.1 21 22 20.1 22 19V5C22 3.9 21.1 3 20 3H12V5H20V19Z" />
									</svg>
									<span>Войти</span>
								</a>
							</router-link>
						</li>
					</ul>
				</div>
			</div>
		</nav>
		<div class="d-flex flex-grow-1" style="height: calc(100vh - 96px)">
			<div
				class="d-flex flex-column flex-shrink-0 p-3 bg-light border-end d-none d-md-block overflow-auto"
				style="width: 280px"
				v-if="authModel.isAuth()"
			>
				<!--
				<table class="table table-bordered">
					<thead>
						<tr>
							<td class="text-center bg-secondary text-white p-1">
								<small>Проекты</small>
							</td>
							<td class="text-center bg-secondary text-white p-1">
								<small>Польз.</small>
							</td>
							<td class="text-center bg-secondary text-white p-1">
								<small>Группы</small>
							</td>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td class="text-center p-1"><b>133</b></td>
							<td class="text-center p-1"><b>12</b></td>
							<td class="text-center p-1"><b>5</b></td>
						</tr>
					</tbody>
				</table>
				-->
				<div class="list-group">
					<router-link custom :to="item.link" v-slot="{ href, navigate, isActive, isExactActive }" v-for="(item, index) in filteredSidebar" :key="index">
						<a
							:href="href"
							@click="navigate"
							class="list-group-item list-group-item-action d-flex align-items-center"
							:class="{ active: item.link == '/' ? isExactActive : isActive }"
						>
							<svg v-if="item.svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20" height="20" class="me-2" v-html="item.svg"></svg>
							<span>{{ item.name }}</span>
							<div class="badge bg-secondary flex-shrink-0 ms-auto" v-if="item.count">{{ item.count }}</div>
						</a>
					</router-link>
				</div>
				<div class="list-group mt-3" v-if="appModel.sidebar2.length > 0">
					<a
						:href="item.link"
						class="list-group-item list-group-item-action d-flex align-items-center px-2"
						:target="item.isTargetBlank ? '_blank' : '_self'"
						v-for="(item, index) in appModel.sidebar2" :key="index"
					>
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20" height="20" class="flex-shrink-0 me-1">
							<path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />
						</svg>
						<span>{{ item.text }}</span>
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="14" height="14" fill="currentColor" class="flex-shrink-0 ms-auto" v-if="item.isTargetBlank">
							<path d="M14,3V5H17.59L7.76,14.83L9.17,16.24L19,6.41V10H21V3M19,19H5V5H12V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V12H19V19Z" />
						</svg>
					</a>
				</div>
			</div>
			<div class="w-100 overflow-auto bg-white pb-3">
				<router-view />
			</div>
		</div>
		<footer class="px-2 py-md-2 text-center border-top border-4 border-danger text-bg-dark bg-dark">
			<small>
				2025 © Made by
				<a href="https://bylex.info" class="text-decoration-none text-white" target="_blank">LexInZector</a>
			</small>
		</footer>
	</div>
</template>

<style lang="scss"></style>

<script>
import lib from "@/lib";
import { useMeta } from "vue-meta";

import ImageWithPlaceholder from '@/components/ImageWithPlaceholder.vue';

export default {
	mixins: lib.mixins,
	setup() {
		useMeta({ title: "SKV" });
	},
	data: () => ({
		sidebar: [
			{
				name: "Главная",
				link: "/",
				svg: '<path d="M10,20V14H14V20H19V12H22L12,3L2,12H5V20H10Z" />',
				requiresAdmin: false,
			},
			{
				id: 'users',
				name: "Пользователи",
				link: "/users",
				svg: '<path d="M12,5.5A3.5,3.5 0 0,1 15.5,9A3.5,3.5 0 0,1 12,12.5A3.5,3.5 0 0,1 8.5,9A3.5,3.5 0 0,1 12,5.5M5,8C5.56,8 6.08,8.15 6.53,8.42C6.38,9.85 6.8,11.27 7.66,12.38C7.16,13.34 6.16,14 5,14A3,3 0 0,1 2,11A3,3 0 0,1 5,8M19,8A3,3 0 0,1 22,11A3,3 0 0,1 19,14C17.84,14 16.84,13.34 16.34,12.38C17.2,11.27 17.62,9.85 17.47,8.42C17.92,8.15 18.44,8 19,8M5.5,18.25C5.5,16.18 8.41,14.5 12,14.5C15.59,14.5 18.5,16.18 18.5,18.25V20H5.5V18.25M0,20V18.5C0,17.11 1.89,15.94 4.45,15.6C3.86,16.28 3.5,17.22 3.5,18.25V20H0M24,20H20.5V18.25C20.5,17.22 20.14,16.28 19.55,15.6C22.11,15.94 24,17.11 24,18.5V20Z" />',
				requiresAdmin: true,
			},
			{
				id: 'projects',
				name: "Проекты",
				link: "/projects",
				svg: '<path d="M13.13 22.19L11.5 18.36C13.07 17.78 14.54 17 15.9 16.09L13.13 22.19M5.64 12.5L1.81 10.87L7.91 8.1C7 9.46 6.22 10.93 5.64 12.5M21.61 2.39C21.61 2.39 16.66 .269 11 5.93C8.81 8.12 7.5 10.53 6.65 12.64C6.37 13.39 6.56 14.21 7.11 14.77L9.24 16.89C9.79 17.45 10.61 17.63 11.36 17.35C13.5 16.53 15.88 15.19 18.07 13C23.73 7.34 21.61 2.39 21.61 2.39M14.54 9.46C13.76 8.68 13.76 7.41 14.54 6.63S16.59 5.85 17.37 6.63C18.14 7.41 18.15 8.68 17.37 9.46C16.59 10.24 15.32 10.24 14.54 9.46M8.88 16.53L7.47 15.12L8.88 16.53M6.24 22L9.88 18.36C9.54 18.27 9.21 18.12 8.91 17.91L4.83 22H6.24M2 22H3.41L8.18 17.24L6.76 15.83L2 20.59V22M2 19.17L6.09 15.09C5.88 14.79 5.73 14.47 5.64 14.12L2 17.76V19.17Z" />',
				requiresAdmin: false,
			},
		],
	}),
	computed: {
		filteredSidebar() {
			const isAdmin = this.appModel.auth.isAdmin();
			
			return this.sidebar
				.filter(item => !item.requiresAdmin || isAdmin)
				.map(item => {
					let count = 0;
					if (item.id === 'users') count = this.appModel.users_count || 0;
					if (item.id === 'projects') count = this.appModel.projects_count || 0;
					return { ...item, count };
				});
		},
	},
	async mounted(){
		// Если авторизован, запускаем остальные обновления в фоне
		if (this.authModel.isAuth()) {
			await Promise.all([
				this.appModel.refreshCounts(),
				this.appModel.refreshSidebarLinks(),
			]);
		}
	},
	components: {
		ImageWithPlaceholder,
	},
};
</script>
